import React, { useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { connect, useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import CreatableSelect from "react-select/creatable";


const DeviceHistory = () => {
    const [imei, setImei] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceData, setDeviceData] = useState(null);
    const [selectedImei, setSelectedImei] = useState(null);
    const access_token = useSelector(state => state.auth.access_token);

    const [imeiOptions, setImeiOptions] = useState([
              { value: '352592572010858', label: '352592572010858 - Honda City' },
              { value: '353691841172736', label: '353691841172736 - Not Mapped' },
              { value: '353691841180044', label: '353691841180044 - Ofc Genset' },
          ]);
    

    const selectTapHandle = (selectedOption, fieldName) => {
        if (fieldName === 'imei') {
            setSelectedImei(selectedOption);
            if (selectedOption) {
                setImei(selectedOption.value);
            } else {
                setImei('');
            }
        }
    };
  const handleImeiCreate = (inputText) => {
        const newOption = {
            value: inputText,
            label: `${inputText} `
        };

        setImeiOptions(prev => [...prev, newOption]);

        setSelectedImei(newOption);
        setImei(inputText);

    };
    const fetchDeviceData = (imei, startDate, endDate) => {
        setLoading(true);
        setDeviceData(null);

        const requestBody = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization('POST', `http://tappetbox.mysolutions.in/api/DeviceData/get-historical`, access_token, {}, requestBody, (resp) => {
            setDeviceData(resp.data);
            toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleDateTimeChange = (field, value) => {
        if (field === 'startDate') {
            setStartDate(value);
        } else if (field === 'endDate') {
            setEndDate(value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedImei) {
            toast.error('Please select an IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        fetchDeviceData(imei, startDate, endDate);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

  const formatValue = (key, value, record = null) => {
    if (value === null || value === undefined) return 'N/A';

    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }

    if (typeof value === 'number') {
        switch (key) {
            case 'speed':
                return `${value} km/h`;
            case 'direction':
                return `${value}°`;
            case 'altitude':
                return `${value} m`;
            case 'externalVoltage':
            case 'batteryVoltage':
                return `${value} V`;
            default:
                return value.toString();
        }
    }


    if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
        return new Date(value).toLocaleString();
    }

    if (key.toLowerCase().includes('imei') && record) {
        const hasValidLocation = record.latitude && record.longitude && 
                               !isNaN(parseFloat(record.latitude)) && !isNaN(parseFloat(record.longitude));
        
        if (hasValidLocation) {
            return (
                <button
                    className="btn btn-link p-0 text-primary text-decoration-none"
                    onClick={() => handleLocationClick(
                        record.latitude, 
                        record.longitude,
                    )}
                >
                    {value}
                </button>
            );
        }
    }

    return value.toString(); 
};

    const renderDeviceData = () => {
        const dataToUse = deviceData;

        if (!dataToUse) return null;

        if (Array.isArray(dataToUse)) {
            if (dataToUse.length === 0) {
                return (
                    <div className="row mt-4">
                        <div className="col-12">
                           <h6> No data found for the selected criteria.</h6>
                        </div>
                    </div>
                );
            }

            return (
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0">
                                Response
                            </h5>
                          
                        </div>

                        <div className="card mt-3">
                            <div className="card-body p-0">
                                <div className="table-responsive" style={{ scrollbarWidth: 'thin' }}>
                                    <table className="table table-hover table-bordered table-fixed">
                                        <thead className="table-secondary">
                                            <tr>
                                                {Object.keys(dataToUse[0]).map((key) => (
                                                    <th key={key} className="text-nowrap text-center">
                                                        {key}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataToUse.map((record, index) => (
                                                <tr key={index}>
                                                    {Object.entries(record).map(([key, value]) => (
                                                        <td key={key} className="text-nowrap text-center">
                                                            {formatValue(key, value, record)}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="row mt-4">
                <div className="col-sm-9">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Response</h5>
                        </div>
                        <table className="table table-hover table-borderless">
                            <tbody>
                                {Object.entries(dataToUse).map(([key, value]) => (
                                    <tr key={key}>
                                        <td className="details-label" style={{ "width": "34%" }}>{key}</td>
                                        <td className="details-name" style={{ "width": "66%" }}>{formatValue(key, value)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Device History</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>Device History</h3>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="imei" className="form-label require">IMEI</label>
                                    </div>
                                    <div className="col-sm-4">
                                         <CreatableSelect
                                            required={true}
                                            value={selectedImei}
                                            options={imeiOptions}
                                            onChange={(selectedOption) => selectTapHandle(selectedOption, 'imei')}
                                            onCreateOption={handleImeiCreate}
                                            isClearable={true}
                                            isMulti={false}
                                            placeholder="Please Select IMEI Number"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: '#dee2e6',
                                                    minHeight: '38px'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="startDate" className="form-label require">Start Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(value) => handleDateTimeChange('startDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Start Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="endDate" className="form-label require">End Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(value) => handleDateTimeChange('endDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter End Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-7"></div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            disabled={loading || !selectedImei}
                                            className="btn btn-primary "
                                        >
                                            GO
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}  
                                        </button>
                                    </div>
                                </div>
                            </form>

                            {loading && <Loader />}

                            {renderDeviceData()}
                        </div>
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default DeviceHistory;